export const IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
export const IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';
